import MagicIcon from '@assets/images/icons/magic-wand.svg';
import { MotionImage, MotionText } from '@shared/atoms';
import { SystemButton } from '@shared/molecules';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import styles from './styles.module.scss';

interface SectionProps {
  nextActionQuestionnaireId: number | null | undefined;
  nextActionQuestionnaire: string | null | undefined;
  topText: string | null;
  middleText: string | null;
  indicatorId: number | null;
}

export const NextActionSection: React.FC<SectionProps> = ({
  nextActionQuestionnaireId,
  nextActionQuestionnaire,
  topText,
  middleText,
  indicatorId,
}) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className={styles.actionsContainer}>
      <div className={styles.recommendedAction}>
        <MotionImage src={MagicIcon} alt="" aria-hidden="true" className={styles.magicIcon} />
        <MotionText
          id="next-assessment-heading"
          as="h3"
          text={topText}
          className={styles.recommendedActionTitle}
        />

        <MotionText as="text" text={middleText} className={styles.recommendedActionText} />
        <SystemButton
          className={styles.actionButton}
          aria-label="Take next assessment"
          onClick={() => {
            if (indicatorId) {
              history.push(
                `/assessment?questionnaireId=${nextActionQuestionnaireId}&indicatorId=${indicatorId}`,
              );
            } else {
              history.push(`/assessment?questionnaireId=${nextActionQuestionnaireId}`);
            }
          }}
        >
          &nbsp;&nbsp;&nbsp;Take {nextActionQuestionnaire || 'Next'} Assessment&nbsp;&nbsp;&nbsp;
        </SystemButton>
      </div>
    </div>
  );
};
